import React from 'react';
import { Layout } from 'antd';
import IconFont from '#/component/IconFont';
import * as classNames from 'classnames';
import { isGray } from '#/util/env';
import UserInfo from '../../../common/UserInfoPop';

import './index.scss';

const HOME_PATH = '/creativeTool/home';
const BASE_CLS = 'creative-tool-header';
const Header = () => (
  <Layout.Header className={BASE_CLS}>
    <div className="df aic jcsb h100">
      <div className={`${BASE_CLS}-left df aic g8`}>
        <div className={classNames(`${BASE_CLS}-logo`, { gray: isGray })} />
        <div className="split-line" />
        <div className="ffpr title">Creative</div>
      </div>
      {/* 用户 && 账户信息部分 */}
      <div className={`df aic`} style={{ gap: 26 }}>
        {window.location.pathname !== HOME_PATH && (
          <div
            onClick={() => {
              window.router.go('creativeTool.home', {
                tryRefresh: true,
              });
            }}
            className={`${BASE_CLS}-icon cp df aic jcsa`}
          >
            <IconFont type="icon-Home" />
          </div>
        )}
        <UserInfo />
      </div>
    </div>
  </Layout.Header>
);
export default Header;
